<script>

import {findIndex} from 'lodash'
import InputSelection from './InputSelection'
import JsonView from './JsonView'
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  components: {
    InputSelection,
    JsonView,
    VJsoneditor,
  },

  props: {
    template: { type: Object },
    action: { type: Object },
    workflow: { type: Object }
  },

  data() {
    return {
      internalAction: this.action
    }
  },

  mounted() {
    if (!this.internalAction.traits) {
      this.$set(this.internalAction, 'traits', [])
    }
    if (!this.internalAction.runtime_traits) {
      this.$set(this.internalAction, 'runtime_traits', false)
    }
  },

  computed: {
    actionIndex() {
      return _.findIndex(this.workflow.actions, (action) => {
        return this.action.uuid == action.uuid
      })
    },

    hasTraits() {
      return this.template.traits && Object.keys(this.template.traits).length > 0
    }
  },

  methods: {
    customizeDefaults(action) {
      this.$set(this.internalAction, 'defaults', this.template.defaults)
      this.$emit('update:action', this.internalAction)
    }
  }
}
</script>

<template>
  <div class="column">

    <b-field horizontal label="Provided Output">
      <b-taglist class="spacing">
        <b-tag v-for="name in template.outputNames" :key="`tag-${name}`">
          <span class="mono">{{ name }}</span>
        </b-tag>
      </b-taglist>
    </b-field>

    <br>

    <b-field horizontal label="Required Input">
      <div>
        <input-selection v-for="(requiredInputName, index) in template.inputNames" :key="`${requiredInputName}-${index}`"
          :inputName="requiredInputName"
          :action="internalAction"
          :collection="workflow.availableOutputs(actionIndex)"
        ></input-selection>
      </div>
    </b-field>

    <hr>

    <b-field horizontal label="Traits" v-if="hasTraits">
      <div class="columns is-multiline traits">
        <div class="column is-4" v-for="(trait, uuid) in template.traits" :key="uuid">
          <b-checkbox :native-value="uuid" v-model="internalAction.traits" :disabled="internalAction.runtime_traits">
            {{ trait.name }}
          </b-checkbox>
        </div>
        <div class="column is-4">
          <b-checkbox v-model="internalAction.runtime_traits">
            Select at runtime
          </b-checkbox>
        </div>
      </div>
    </b-field>

    <b-field horizontal label="Custom Name">
      <b-input type="text" v-model="internalAction.name"></b-input>
    </b-field>

    <b-field horizontal label="Defaults" v-if="template.hasDefaultParams">
      <div class="defaults" v-if="internalAction.defaults">
        <v-jsoneditor v-model="internalAction.defaults" :options="{'mode': 'code'}" :plus="false" height="400px">
        </v-jsoneditor>
        <br>
        <b-button @click="internalAction.defaults = null" size="is-small" icon-left="code-braces">Back to Defaults</b-button>
      </div>
      <div class="defaults" v-else>
        <json-view :flatObject="template.defaults"></json-view>
        <br>
        <b-button @click="customizeDefaults(internalAction)" size="is-small" icon-left="code-braces">Customize Defaults</b-button>
      </div>
    </b-field>

  </div>
</template>

<style lang="scss" scoped>
.traits {
  margin-bottom: 10px !important;
}
</style>